import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FinancialInstitution } from '@store/core/core.interface';
import { selectConsentId } from '@store/checkout/checkout.selectors';
import { selectFI } from '@store/core/core.actions';
import { SNAME } from '@core/constants/storage';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FiSelectionService {
  constructor(
    private store: Store,
  ) {}

  fiSelected(
    selectedFI: FinancialInstitution,
    userProfileRef?: string, // Only pass during step-up and linking new FI, otherwise undefined
    standalone: boolean = false,
    redirectUrl: string = '',
    authentication: boolean = true
  ): void {
    const selectFIPayload: {
      selectedFI: any;
      redirectUrl: string;
      userProfileRef?: string;
      email?: string;
      rus?: boolean;
    } = {
      selectedFI,
      redirectUrl,
    };

    if (userProfileRef) {
      selectFIPayload.userProfileRef = userProfileRef;
    }

    if (authentication) {
      sessionStorage.setItem(SNAME.AUTH_METHOD, selectedFI.id || '');
    }

    if (standalone) {
      this.store.dispatch(selectFI(selectFIPayload));
    } else {
      this.store
        .select(selectConsentId)
        .pipe(take(1))
        .subscribe((consentId) => {
          this.store.dispatch(selectFI({ ...selectFIPayload, consentId }));
        });
    }
  }
}
